import { TextFieldProps } from 'components_new/atoms/TextField'
import { TFunction } from 'language/translator'

export type TVariant = 'default' | 'email' | 'multiline'

export function getVariantProps(variant: TVariant): TextFieldProps {
  if (variant === 'multiline') {
    return {
      multiline: true,
      rows: 3
    }
  }
  if (variant === 'email') {
    return {
      type: 'email',
      inputMode: 'email',
      autoComplete: 'email'
    }
  }

  return {}
}

export function getErrorMessage(
  value: string,
  variant: string,
  t: TFunction
): string | null {
  if (variant === 'email') {
    return value.length === 0 || !value.includes('@')
      ? t('users', 'email_error')
      : null
  }

  return null
}

export function getLabel(
  label: string | undefined,
  variant: TVariant,
  t: TFunction
) {
  if (label) {
    return label
  }

  // if no label then fallback to variants label
  if (variant === 'email') {
    return t('users', 'email')
  }

  return undefined
}
